import {z} from 'zod'

export const EntityTypes = ['user', 'patient', 'project', 'treatment_request'] as const
export type EntityType = (typeof EntityTypes)[number]

export const EntityUrlTypes = ['users', 'patients', 'projects', 'treatment-requests'] as const
export type EntityUrlType = (typeof EntityUrlTypes)[number]

const URL_TO_ENTITY_MAPPING = {
    users: 'user',
    patients: 'patient',
    projects: 'project',
    'treatment-requests': 'treatment_request'
} as const satisfies Record<EntityUrlType, EntityType>

const ENTITY_TO_URL_MAPPING = {
    user: 'users',
    patient: 'patients',
    project: 'projects',
    treatment_request: 'treatment-requests'
} as const satisfies Record<EntityType, EntityUrlType>

export const getEntityTypeFromUrl = (urlType: EntityUrlType): EntityType => URL_TO_ENTITY_MAPPING[urlType]
export const getUrlTypeFromEntity = (entityType: EntityType): EntityUrlType => ENTITY_TO_URL_MAPPING[entityType]

export const ActionTypes = ['create', 'update', 'delete'] as const
export type ActionType = (typeof ActionTypes)[number]

export const ResponseTypes = ['small', 'extended'] as const
export type ResponseType = (typeof ResponseTypes)[number]

export const LogUserSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string()
})

export type LogUser = z.infer<typeof LogUserSchema>

export const ActivityLogSchema = z.object({
    id: z.string(),
    userId: z.string(),
    entityId: z.string(),
    entityType: z.enum(EntityTypes),
    action: z.enum(ActionTypes),
    createdAt: z.string(),
    oldData: z.record(z.any()).nullable(),
    newData: z.record(z.any()).nullable(),
    user: LogUserSchema.optional()
})

export type ActivityLog = z.infer<typeof ActivityLogSchema>

export const PaginationMetaSchema = z.object({
    total: z.number(),
    perPage: z.number(),
    currentPage: z.number(),
    lastPage: z.number(),
    firstPage: z.number(),
    firstPageUrl: z.string(),
    lastPageUrl: z.string(),
    nextPageUrl: z.string().nullable(),
    previousPageUrl: z.string().nullable()
})

export type PaginationMeta = z.infer<typeof PaginationMetaSchema>

export const ActivityLogsResponseSchema = z.object({
    meta: PaginationMetaSchema,
    data: z.array(ActivityLogSchema)
})

export type ActivityLogsResponse = z.infer<typeof ActivityLogsResponseSchema>

export interface ActivityLogsQueryParams {
    page?: number
    limit?: number
    action?: ActionType
    startDate?: string
    endDate?: string
    userId?: string
    responseType?: ResponseType
}
